module.exports = __webpack_public_path__ + "img/14c-doc-acao-cancelar.79b24b87.png";